import React, { Component } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import clsx from 'clsx'
import {
  monsterOptions,
  funnyFaceOptions,
  outlinedOptions,
  flatFaceOptions,
} from './optionSvgs'
import RawHtml from 'stories/components/RawHtml'

const Radio = ({ value, label, checked, onCheck, name }) => (
  <div className="formMaker-nps-radio-wrapper">
    <input
      type="radio"
      checked={checked}
      id={`npsRadio-${value}`}
      onChange={() => onCheck(value)}
    />
    <label htmlFor={`npsRadio-${value}`} className="nps-radio-label">
      <img src={label} alt="" />
      <span className="nps-radio-name-wrapper">
        <span className="nps-radio-name">{name}</span>
      </span>
    </label>
  </div>
)

class NpsRadio extends Component {
  constructor(props) {
    super(props)
    this.state = { selected: '', isHover: false }
  }

  onInputChange = ({ selectedOptions, shouldUpdateParent }) => {
    this.setState({ selected: selectedOptions }, () => {
      shouldUpdateParent && this.props.onChange(selectedOptions)
    })
  }

  onOption = (selectedOptions) => {
    this.onInputChange({
      selectedOptions,
      shouldUpdateParent: true,
    })
  }

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺👍
    const { value } = this.props
    if (value) {
      this.onInputChange({
        selectedOptions: value,
        shouldUpdateParent: false,
      })
    }
  }

  generateOptions = (options = []) =>
    options.map((option, index) => (
      <Radio
        key={option.value + index}
        {...option}
        onCheck={this.onOption}
        checked={option.value === this.state.selected}
      />
    ))

  isFieldHover = () => {
    this.setState({
      isHover: !this.state.isHover,
    })
  }

  render() {
    const {
      label = '',
      touched,
      error,
      description,
      thumbnail_type,
    } = this.props

    const classNames = {
      'formz-radio-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    const npsType = {
      monster: monsterOptions,
      funny_face: funnyFaceOptions,
      outlined: outlinedOptions,
      flat_face: flatFaceOptions,
    }
    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <div className="formz-field-and-label-holder">
          <div className="formz-input-title">{label}</div>

          <RawHtml className="formz-field-description" content={description} />

          <div
            className={clsx({
              'formMaker-formz-radio-group-container': true,
              ' formz-input-field': true,
            })}
            onMouseEnter={() => {
              this.isFieldHover()
            }}
            onMouseLeave={() => {
              this.isFieldHover()
            }}
          >
            {this.generateOptions(npsType[thumbnail_type])}
          </div>
        </div>
      </FieldRowWrapper>
    )
  }
}

export default NpsRadio
